// service/websitePlanPaymentService.js
//
// Mirrors the shape of your existing websitePlanService / otherChargeService
// (getAll-style calls returning { data }, plus a normalize helper).
//
// ⚠️ ADJUST THIS: I don't have your real API client, so this reads the auth
// token from localStorage under "token". If your app stores it under a
// different key (or attaches it via cookies / an axios instance), change
// only the `authHeaders()` function below — nothing else needs to change.

import { fetchWrapper } from "utils/apiFetch";

const API_BASE = "https://pro.mokshiq.in"; // adjust if your endpoints are mounted elsewhere

function authHeaders() {
  const token = localStorage.getItem("token"); // ⚠️ adjust key if different
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function postForm(url, params = {}) {
  const body = new URLSearchParams(params);
  const json = await fetchWrapper(`${API_BASE}/${url}`, {
    method: "POST",
    body,
  });
  
  return json;
}

export const websitePlanPaymentService = {
  // GET what's currently due this billing cycle
  getDue: () => postForm("plan_payment_due"),

  // POST — pay the due amount from main_wallet
  pay: () => postForm("pay_website_plan"),

  // GET payment history rows for PaymentHistory.jsx
  getHistory: () => postForm("website_plan_payment_history"),

 
  // Main Admin only — assign a plan to an Admin / White Label
  activatePlan: (userId, websitePlanId) =>
    postForm("activate_website_plan", { user_id: userId, website_plan_id: websitePlanId }),
 
  // Main Admin only — list Admin/White Label accounts + their current plan status
  getAssignableUsers: () => postForm("assignable_plan_users"),
};